import React, { useState, useEffect, useRef } from 'react'
import Seo from 'components/seo'
import Layout from 'layouts/zh'
import Button, { ButtonGroup } from 'components/Base/Button'
import SolutionsBanner from 'components/SolutionsBanner'
import SectionContent, { SectionHeaderMobile } from 'components/SectionContent'
import PictureSwiper from 'components/PictureSwiper'
import SolutionsSwiper from 'components/SolutionsSwiper'
import SolutionsSwiperMobile from 'components/SolutionsSwiperMobile'
import MaterialCard, { MaterialCardGroup, MaterialCardTypes } from 'components/MaterialCard'
import ScanCodeConsultButton from 'components/ScanCodeConsultButton'
import PageBottomCard from 'components/PageBottomCard'
import Video from 'components/Base/Video'
import SwiperCore, { Pagination, Scrollbar, A11y, Autoplay, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { isPc } from 'utils/utils'

import 'swiper/swiper.min.css'
import * as styles from './index.module.less'

import IconArrow from 'assets/images/solution/ma/icon-arrow.svg'

SwiperCore.use([Pagination, Scrollbar, A11y, Autoplay, Navigation])

const MA: React.FC = (props) => {
  return (
    <Layout {...props}>
      <MAState
        pageTitle="营销自动化｜自动化营销平台 - 神策数据"
        description="神策营销自动化平台通过画布策略引擎、全触点覆盖、内容管理和营销数据可视化分析四大要素，帮助客户快速选定目标人群，制定营销策略，提升数字化营销能力，实现多渠道智能营销和精准营销。"
        keywords="营销工具,营销自动化,自动化营销,自动化营销系统,自动化营销平台"
        saTitle="首页｜营销自动化解决方案专题页"
        bannerDesc="营销自动化（MA）帮助营销人员选定目标人群，制定并自动化地执行营销策略，实现多渠道精准触达，给用户提供个性化体验，从而提升营销效果。"
      />
    </Layout>
  )
}
interface MAStateProps {
  pageTitle?: string
  description?: string
  keywords?: string
  saTitle?: string
  bannerTitle?: string
  bannerSubTitle?: string
  bannerDesc?: string
}
export const MAState: React.FC<MAStateProps> = (props) => {
  const { pageTitle, description, keywords, saTitle, bannerDesc, children } = props
  const [inPC, setInPC] = useState<boolean>(isPc())
  const [currentPlay, setCurrentPlay] = useState<number>()

  useEffect(() => {
    window.onresize = () => {
      setInPC(isPc())
    }
  }, [])

  // 更多关于营销的实战资料
  const MaterialList = [
    {
      imgSrc: require(`assets/images/solution/ma/material_01.png`).default,
      title: '解读未来营销的关键要素',
      desc: '如果五年内企业的营销思路一成不变，那么就会被市场淘汰',
      href: 'https://www.sensorsdata.cn/market/playback-detail.html?id=4030',
      buttonText: '免费下载文档',
      type: MaterialCardTypes.Document,
    },
    {
      imgSrc: require(`assets/images/solution/ma/material_02.png`).default,
      title: '玩转微信生态私域营销',
      desc: '30+ 企业深度访谈，解密 12+ 亿微信生态流量池的十大玩法',
      href: 'https://www.sensorsdata.cn/school/library/4bd1dcdf9bcfa5181b5545623200573e',
      buttonText: '免费下载白皮书',
      type: MaterialCardTypes.Whitepaper,
    },
    {
      imgSrc: require(`assets/images/solution/ma/material_03.png`).default,
      title: '搭建可落地的私域体系',
      desc: '数字化浪潮下，让私域营销成为餐饮企业增长的新引擎',
      href: 'https://www.sensorsdata.cn/market/playback-detail.html?id=4005',
      buttonText: '免费观看课程',
      type: MaterialCardTypes.Video,
    },
    {
      imgSrc: require(`assets/images/solution/ma/material_04.png`).default,
      title: '典型的场景实践',
      desc: '通过营销自动化，实现公域 + 私域的用户自动化触达和有效互动',
      href: 'https://www.sensorsdata.cn/school/library/53d163d6135338703fb60a19a9f999b7',
      buttonText: '免费下载白皮书',
      type: MaterialCardTypes.Whitepaper,
    },
  ]
  // 这些企业正在用神策营销自动化创造价值
  const CustomerVideos = [
    {
      title: '小米集团：数据驱动市场营销',
      poster: require(`assets/images/solution/ma/poster_01.png`).default,
      isPlaying: false,
      videoUrl:
        'https://video.sensorsdata.cn/fb078d36627f4389bdde5fb5b21b0222/18ca03e42f6641d8b11230cb006ba95d-5f2993bad613fe30ebc0ad89ae54ec16-sd.mp4',
    },
    {
      title: '华农保险：以客户为中心的营销触达',
      poster: require(`assets/images/solution/ma/poster_02.png`).default,
      isPlaying: false,
      videoUrl:
        'https://video.sensorsdata.cn/dbd9d198502e4d02a988a2c3293df3fd/04336dc0e62041f59eaab385b6d6cf28-0e84bdad2055dbeb2ca519b944837704-ld.mp4',
    },
  ]

  return (
    <>
      <Seo title={pageTitle} description={description} keywords={keywords} saTitle={saTitle} />
      <main className={styles.MAContainer}>
        <SolutionsBanner
          className="banner-wrap"
          title={'营销自动化解决方案'}
          subTitle={'简化工作流，自动执行营销任务，提升营销效果'}
          desc={bannerDesc}
          imgUrl={<img src={require(`assets/images/solution/ma/banner.png`).default} alt="" className="banner-icon" />}
          buttonGroup={
            <Button href="/doMatrixSf?formpage_source2=营销自动化" target="_blank">
              体验营销自动化 Demo
            </Button>
          }
        />
        <SectionContent className="section-02">
          <SectionHeaderMobile title="前沿洞察" />
          <a className="left" href="https://www.sensorsdata.cn/market/playback-detail.html?id=4088" target="_blank">
            <img src={require(`assets/images/solution/ma/kotler.gif`).default} alt="" />
            <div className="float">
              <h3>菲利普·科特勒谈营销的未来之“营销自动化”</h3>
              <div className="sd-button-group">
                <Button btnType="primary" target="_blank">
                  观看完整解读
                </Button>
              </div>
            </div>
          </a>
          <div
            className="right"
            onClick={() => {
              if (!inPC) window.location.href = 'https://sdmarketing.wjx.cn/vj/h7J0C2V.aspx'
            }}
          >
            <img className="ceyice" src={require(`assets/images/solution/ma/ceyice.png`).default} alt="" />
            <div className="right-content">
              <h3>
                营销自动化用得怎么样？
                <br />
                快来免费测一测
              </h3>
              <p>
                从“需求实现”与“价值创造”两个维度，
                <br />
                自评营销自动化的应用效果
              </p>
              <div className="sd-button-group">
                <Button href={inPC ? 'https://sdmarketing.wjx.cn/vj/h7J0C2V.aspx' : undefined} target="_blank">
                  测一测
                </Button>
              </div>
            </div>
          </div>
        </SectionContent>
        <SectionContent className="section-03" title="从认知到应用，全面解读营销自动化" backgroundColor="#F5FBFF">
          <SectionHeaderMobile
            title="实战资料"
            right={
              <Button href="//www.sensorsdata.cn/school/library" btnType="link" size="small">
                更多资料 <img className="icon-arrow" src={IconArrow} alt="" />
              </Button>
            }
          />
          <div className="section-03--content">
            <div
              className="left"
              onClick={() => {
                if (!inPC)
                  window.location.href = 'https://www.sensorsdata.cn/school/library/172863edbea3e1ee82d2fa2a9e9ad1ff'
              }}
            >
              <p className="desc-mb hidden-pc">营销人必读！走访上千家企业，八大行业的营销自动化应用实践</p>
              <img src={require(`assets/images/solution/ma/section_03_thumb.png`).default} alt="" />
            </div>
            <div className="right hidden-mb">
              <h3>《营销自动化应用基准报告 2021》</h3>
              <p>营销人必读！走访上千家企业，八大行业的营销自动化应用实践</p>
              <ul>
                <li>类型：研究报告</li>
                <li>页数：56 页</li>
                <li>关键词：概念认知，应用现状，驱动力，应用场景，应用建议</li>
              </ul>
              <PictureSwiper
                className="picture-swiper-wrap"
                dataSource={[
                  require(`assets/images/solution/ma/report-content-01.png`).default,
                  require(`assets/images/solution/ma/report-content-02.png`).default,
                  require(`assets/images/solution/ma/report-content-03.png`).default,
                  require(`assets/images/solution/ma/report-content-04.png`).default,
                  require(`assets/images/solution/ma/report-content-05.png`).default,
                  require(`assets/images/solution/ma/report-content-06.png`).default,
                  require(`assets/images/solution/ma/report-content-07.png`).default,
                  require(`assets/images/solution/ma/report-content-08.png`).default,
                  require(`assets/images/solution/ma/report-content-09.png`).default,
                ]}
              />
              <div className="sd-button-group">
                <Button
                  btnType="primary"
                  href="https://www.sensorsdata.cn/school/library/172863edbea3e1ee82d2fa2a9e9ad1ff"
                  target="_blank"
                >
                  免费下载
                </Button>
              </div>
            </div>
          </div>
          <MaterialCardGroup>
            {MaterialList?.map((item) => (
              <MaterialCard key={item.title} {...item} />
            ))}
          </MaterialCardGroup>
        </SectionContent>
        <SectionContent className="section-04" title="实现营销自动化的四大要素">
          <SectionHeaderMobile title="实现营销自动化的四大要素" />
          {/* pc端 */}
          <SolutionsSwiper
            className="solutions-swiper-wrap"
            dataSource={[
              {
                className: 'feature-01',
                icon: 'engine',
                tabText: (
                  <>
                    画布
                    <br className="hidden-pc" />
                    策略引擎
                  </>
                ),
                title: '赋能营销的自动化、实时性、智能化',
                imgUrl: require('assets/images/solution/ma/feature_01.png').default,
                imgWidth: 630,
                descList: [
                  {
                    title: '联动多个策略引擎，构建个性化用户旅程，满足复杂业务场景',
                  },
                  {
                    title: '不局限于既定营销工作流，实现实时的行为触发型营销',
                  },
                ],
                buttonList: [
                  {
                    text: '体验营销自动化 Demo',
                    href: '/doMatrixSf?formpage_source2=营销自动化',
                    target: '_blank',
                    type: 'primary',
                  },
                ],
              },
              {
                className: 'feature-02',
                icon: 'bank-03',
                tabText: (
                  <>
                    覆盖
                    <br className="hidden-pc" />
                    全触点
                  </>
                ),
                title: '实现全触点的用户有效触达及互动',
                imgUrl: require('assets/images/solution/ma/feature_02.png').default,
                imgWidth: 630,
                descList: [
                  {
                    title: '以新一代 ID-Mapping 为基础，实现用户唯一标识',
                  },
                  {
                    title: '串联公域、私域等生态的营销触点，提升触达的有效性',
                  },
                ],
                buttonList: [
                  {
                    text: '体验营销自动化 Demo',
                    href: '/doMatrixSf?formpage_source2=营销自动化',
                    target: '_blank',
                    type: 'primary',
                  },
                ],
              },
              {
                className: 'feature-03',
                icon: 'doc',
                tabText: (
                  <>
                    内容
                    <br className="hidden-pc" />
                    管理
                  </>
                ),
                title: '一站式营销资产管理，搭建内容开放生态',
                imgUrl: require('assets/images/solution/ma/feature_03.png').default,
                imgWidth: 630,
                descList: [
                  {
                    title: '一站式营销资产管理，实现内容的创意、分发、标签化等',
                  },
                  {
                    title: '搭建内容生态开放平台，提升素材创意性和丰富度',
                  },
                ],
                buttonList: [
                  {
                    text: '体验营销自动化 Demo',
                    href: '/doMatrixSf?formpage_source2=营销自动化',
                    target: '_blank',
                    type: 'primary',
                  },
                ],
              },
              {
                className: 'feature-04',
                icon: 'bank-02',
                tabText: (
                  <>
                    营销
                    <br className="hidden-pc" />
                    数据分析
                  </>
                ),
                title: '营销效果实时反馈，不断迭代形成闭环',
                imgUrl: require('assets/images/solution/ma/feature_04.png').default,
                imgWidth: 630,
                descList: [
                  {
                    title: '营销活动数据看板，效果实时查看、一目了然',
                  },
                  {
                    title: '支持进一步下钻分析，赋能策略迭代',
                  },
                ],
                buttonList: [
                  {
                    text: '体验营销自动化 Demo',
                    href: '/doMatrixSf?formpage_source2=营销自动化',
                    target: '_blank',
                    type: 'primary',
                  },
                ],
              },
            ]}
          />
          {/* 移动端 */}
          <SolutionsSwiperMobile
            dataSource={[
              {
                title: '画布策略引擎，赋能营销的自动化、实时性、智能化',
                imgUrl: require('assets/images/solution/ma/feature_01.png').default,
              },
              {
                title: '实现全触点的用户有效触达及互动',
                imgUrl: require('assets/images/solution/ma/feature_02.png').default,
              },
              {
                title: '一站式营销资产管理，搭建内容开放生态',
                imgUrl: require('assets/images/solution/ma/feature_03.png').default,
              },
              {
                title: '营销效果实时反馈，不断迭代形成闭环',
                imgUrl: require('assets/images/solution/ma/feature_04.png').default,
              },
            ]}
          />
          {/* 移动端按钮 */}
          <ButtonGroup className="hidden-pc">
            <Button btnType="primary" href="/doMatrixSf?formpage_source2=营销自动化" target="_blank">
              体验营销自动化 Demo
            </Button>
          </ButtonGroup>
        </SectionContent>
        {/* pc端显示，移动端隐藏 */}
        <SectionContent className="section-05" title="更多关于营销的实战资料" backgroundColor="#F5FBFF">
          <MaterialCardGroup>
            {MaterialList?.map((item) => (
              <MaterialCard key={item.title} {...item} />
            ))}
          </MaterialCardGroup>
        </SectionContent>
        <SectionContent className="section-06" title="这些企业正在用神策营销自动化创造价值">
          <SectionHeaderMobile title="这些企业正在用神策营销自动化创造价值" />
          {/* PC端 */}
          <div className="video-list hidden-mb">
            {CustomerVideos?.map((item, index) => (
              <div className="video-item" key={item.title}>
                <Video
                  source={[
                    {
                      src: item.videoUrl,
                      type: 'video/mp4',
                    },
                  ]}
                  playStatus={currentPlay === index}
                  poster={item.poster}
                  onPlayCallback={() => {
                    setCurrentPlay(index)
                    item.isPlaying = true
                  }}
                />
                {!item.isPlaying && <h3 className="video-title">{item.title}</h3>}
              </div>
            ))}
          </div>
          {/* 移动端 */}
          <Swiper className="video-list-swiper hidden-pc" pagination={{ clickable: true }} autoplay={false}>
            {CustomerVideos?.map((item, index) => (
              <SwiperSlide key={item.title}>
                <div className="video-item">
                  <Video
                    source={[
                      {
                        src: item.videoUrl,
                        type: 'video/mp4',
                      },
                    ]}
                    playStatus={currentPlay === index}
                    poster={item.poster}
                    onPlayCallback={() => {
                      setCurrentPlay(index)
                      item.isPlaying = true
                    }}
                  />
                  {!item.isPlaying && <h3 className="video-title">{item.title}</h3>}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="sd-button-group hidden-mb">
            <ScanCodeConsultButton
              buttonText="扫码咨询营销自动化专家"
              qrcode={require(`assets/images/solution/ma/qrcode1.png`).default}
            />
          </div>
          <div className="logo-wall lg:!pl-[0]">
            <img
              className="hidden-mb lg:mx-auto"
              src={require(`assets/images/solution/ma/customer_logo.png`).default}
              alt=""
            />
            <img className="hidden-pc" src={require(`assets/images/solution/ma/customer_logo_mb.png`).default} alt="" />
          </div>
        </SectionContent>
        <PageBottomCard
          title="立即预约，构建营销闭环、提升营销效果！"
          desc="和神策业务专家一起挖掘营销自动化的巨大价值！"
          leftButtonText="体验营销自动化 Demo"
          leftButtonHref="/doMatrixSf?formpage_source2=营销自动化"
          rightButtonText="预约演示"
          rightButtonHref="/form/parade.html?formpage_source2=营销自动化预约演示"
        />
      </main>
      {children}
    </>
  )
}

export default MA
